export default {
  translation: {
    'form.validation.required': '{{field_name}} は必須です',
    'form.validation.maxlength': '{{field_name}} が長すぎます',
    'form.validation.minlength': '{{field_name}} が短すぎます',
    'form.validation.invalid': '{{field_name}} は無効です',
    'form.validation.unique':
      '{{field_name}} は選択済みです。再入力してください。',
    'membership.profile.optional_field': '（オプション）',
    'dropdown.hint': '選択してください',

    'member_points.title': 'メンバーポイント',
    'member_points.unit': 'ポイント',
    'member_points.point_balance': '現在の合計ポイント',
    'member_points.point_history': 'ポイント履歴',
    'member_points.fields.date': '日付',
    'member_points.rule': 'ポイントルール説明',
    'member_points.display.expire_point': 'クリック',
    'member_points.display.successive_expire_point': 'クリック',
    'member_points.fields.expire': '期限切れ',
    'member_points.fields.expired': 'ポイント有効期限切れ',
    'member_points.fields.successive_expire': 'まもなく期限切れ',
    'member_points.fields.remarks': 'ポイント変更理由',
    'member_points.fields.value': 'ポイント',
    'member_points.fields.expiry_date': '有効期限',
    'member_points.fields.member_point_expired': 'ポイント有効期限切れ',
    'member_points.fields.auto_reward': '注文中',
    'member_points.fields.auto_reward_seconds': 'ポイント獲得',
    'member_points.no_data': '履歴なし',
    'member_points.equal_cash': '{{money}}相当',
    'member_points.redeem_cash_and_earn_from_order_description':
      '{{costMoney}} 購入で {{earnPoint}} ポイント獲得、{{costPoint}} ポイントで {{discountMoney}} 割引。',
    'member_points.redeem_cash_description':
      '{{costPoint}} ポイントで {{discountMoney}} 割引。',
    'member_points.earn_from_order_description':
      '{{costMoney}} 購入で {{earnPoint}} ポイント獲得',
    'member_points.fields.revert_member_point':
      '補充ポイント：注文キャンセル済み',
    'member_points.fields.revert_member_point.return':
      '補充ポイント：注文返品済み',
    'member_points.fields.revert_member_point.order_split':
      '補充ポイント：分割注文',
    'member_points.fields.revert_member_point.order_edit':
      '補充ポイント：注文編集',
    'member_points.fields.revert_member_point.return_order_revert':
      '補充ポイント：返品',
    'member_points.fields.product_review_reward':
      '完了した注文<a href="{{link}}">{{ orderNumber }}</a>のレビュー',
    'member_points.fields.member_info_reward':
      'メンバープロフィール特典　メンバーポイント',
    'store_credits.fields.display.never_expired': '期限なし',
    'member_points.fields.order_redeemed': 'ポイント利用で注文時にギフトと交換',
    'member_points.fields.redeemed_to_cash':
      'ポイント利用で注文の商品を現金割引',
    'member.center.load.more': 'さらに読み込む',
    'store_credits.fields.never_expires_point': 'ポイント期限なし',
    'member_points.display.redeem_btn': 'ギフト交換',
    'promotions.page.term.confirm': '確認',

    'store_credits.title': 'ストアクレジット',
    'store_credits.credit_balance': '保有のショッピングクレジット',
    'store_credits.credit_history': 'ショッピングクレジット履歴',
    'store_credits.fields.date': '日付',
    'store_credits.fields.remarks': 'ショッピングクレジット項目',
    'store_credits.fields.value': 'ショッピングクレジット',
    'store_credits.fields.expiry_date': '有効期限',
    'store_credits.fields.balance': 'ショッピングクレジット残高',
    'store_credits.fields.order_prefix':
      'この注文でショッピング クレジットが使用されました',
    'store_credits.fields.welcome_credit': '新規メンバーショッピングクレジット',
    'store_credits.fields.member_referral_credit':
      '新規顧客に購入をおすすめする',
    'store_credits.fields.member_info_quick_completion_credit':
      'メンバープロフィール特典　ショッピングクレジット',
    'store_credits.fields.welcome_member_referral_credit':
      '紹介リンク経由での登録が完了しました',
    'store_credits.fields.birthday_credit': '誕生日ショッピングクレジット',
    'store_credits.fields.user_credit_expired':
      'ショッピングクレジットの有効期限が切れました',
    'store_credits.fields.never_expires': '期限なし',
    'store_credits.fields.auto_reward_prefix': '注文 ',
    'store_credits.fields.auto_reward': 'ショッピングクレジット獲得',
    'store_credits.fields.revert_credit':
      'ショッピングクレジット補充：キャンセル済みの注文',
    'store_credits.fields.revert_credit.return':
      'ショッピングクレジット補充：返品済みの注文',
    'store_credits.fields.revert_credit.order_split':
      'ショッピングクレジット補充：分割注文',
    'store_credits.fields.revert_credit.order_edit':
      'ショッピングクレジット補充：注文の編集',
    'store_credits.fields.revert_credit.return_order_revert':
      'ショッピングクレジット補充：返品',
    'store_credits.fields.product_review_reward':
      '完了した注文<a href="{{link}}">{{ orderNumber }}</a>のレビュー',
    'store_credits.no_data': '履歴なし',
    'store_credits.bulk_imported': 'ショッピングクレジットを手動で追加',
    'member_point.list.empty.description':
      'チェックアウトでポイントを貯めて、さらに割引を獲得！',
    'store_credits.list.empty.description':
      'チェックアウトでショッピングクレジットを貯めて、さらに割引を獲得!',
    'member_center.list.empty.buttonText': '今すぐ購入',
    // Member Profile
    'member_profile.member_info.title': 'メンバープロフィール特典',
    'member_profile.member_info.name': '名前',
    'member_profile.member_info.email': 'メールアドレス',
    'member_profile.member_info.mobile': '電話番号',
    'member_profile.member_info.gender': '性別',
    'member_profile.member_info.birthday': '生年月日',
    'member_profile.member_info.symbol': '、',
    'member_profile.member_info.hint.fields_only':
      '以下のメンバープロフィールを入力: {{fields}}。入力完了で {{rewards}} を獲得！',
    'member_profile.member_info.sent':
      'メンバープロフィール確認完了後、特典が進呈されます！',
    'member_profile.member_info.user_credits':
      '{{count}} 円のショッピングクレジット',
    'member_profile.member_info.member_points': '{{count}} メンバーポイント',
    'member_profile.member_info.coupons': '{{count}} クーポン',
    'member_profile.member_referral.discount': 'メンバーおすすめ割引',
    'member_profile.member_referral.rules': 'キャンペーンルール説明',
    'member_profile.member_referral.code.copy_and_share':
      'リンクをコピーして友達にシェアすると、ショッピング クレジットを獲得できます。',
    'member_profile.member_referral.code.remarks': 'キャンペーンルール説明',
    'member_profile.member_referral.generate': '推薦リンク',
    'member_profile.member_referral.generate.success': '生成完了',
    'member_profile.member_referral.copy': 'リンクをコピー',
    'member_profile.member_referral.copy.success': 'コピー完了',
    'membership.profile.email': 'メールアドレス',
    'membership.profile.verification_hint':
      'メールアドレスを変更される場合は、保存後に認証する必要があります。認証が完了すると {{unconfirmedEmail}} に更新されます。',
    'membership.profile.verified_success': '認証完了',
    'membership.profile.not_verified_yet': '認証されていません',
    'membership.profile.send_verification_email': '認証メールを送信',
    'users.save.email_verification.success':
      '変更が保存されました。認証が完了するとメールアドレスが更新されます',
    'users.save.email_verification.send': '認証メールが送信されました',
    'user.sign_up.email_verification.dialog.title':
      '認証メールが {{email}} に送信されました',
    'user.sign_up.email_verification.dialog.description':
      'お早めにメールアドレスの認証を完了し、メールアドレスを更新してください。認証メールが届かない場合は、再度メールアドレスを変更して保存してください。',
    'user.sign_up.email_verification.dialog.confirm': '了解',

    'users.membership.member_info.title': 'メンバープロフィール特典',
    'users.membership.member_info.hint':
      '次のメンバープロフィールを入力: {{fields}}。入力完了で {{rewards}} を獲得！',
    'users.membership.member_info.sent':
      'メンバープロフィール確認完了後、特典が進呈されます！',
    'users.membership.member_info.symbol': '、',
    'users.membership.member_info.name': '名前',
    'users.membership.member_info.email': 'メールアドレス',
    'users.membership.member_info.mobile': '電話番号',
    'users.membership.member_info.gender': '性別',
    'users.membership.member_info.gender.male': '男性',
    'users.membership.member_info.gender.female': '女性',
    'users.membership.member_info.gender.other': '回答なし',
    'users.membership.member_info.birthday': '生年月日',
    'users.membership.member_info.password': 'パスワード',
    'users.membership.member_info.password.change': '新しいパスワードを設定',
    'users.membership.member_info.account_binding': 'サードパーティ登録',
    'users.membership.member_info.user_credits':
      '{{count}} 円のショッピングクレジット',
    'users.membership.member_info.member_points': '{{count}} メンバーポイント',
    'users.membership.member_info.coupons': '{{count}} クーポン',
    'users.membership.forget_password.email_sent':
      'アカウント認証メールを {{email}} に送信しました。\nメールを受信して​​パスワードのリセットを行ってください。',
    'users.member.normal-level': '一般メンバー',
    'users.membership.expiry_date': 'メンバー有効期限',
    'users.membership.expire.unlimited': '有効期限なし',
    'users.membership.expire.month_valid': '（有効期間 {{months}} ヶ月）',
    'users.membership.tier.expire.date.description':
      '自動更新は注文決済完了日の翌日早朝に実行されます。注文のキャンセルや返品等によりアップグレード条件を満たしていない場合、アップグレードは実行されません。',
    'users.membership.tier.expire.date.auto_downgrade.description':
      '自動更新は注文ステータスが完了になった翌日早朝に実行されます。注文のキャンセルや返品等によりアップグレード条件を満たしていない場合、アップグレードは実行されません。',
    'users.membership.tier.extension.date.description':
      'メンバーの有効期限が切れた際、注文のキャンセル・返品等により注文状況が更新条件を達成しなかった場合、メンバー資格は更新されません。',
    'users.membership.offer.discount': '特別割引',
    'users.membership.upgrade.next_tier': '{{tier_name}} にアップグレードで',
    'users.membership.upgrade.next_tier.discount':
      '、 {{discount}} 割引をご利用いただけます',
    'users.membership.extension.condition': 'メンバーシップ更新条件',
    'users.membership.extension.status': '更新ステータス',
    'users.membership.max_level_tier':
      'おめでとうございます！メンバーグレードがハイレベルに到達しました！',
    'users.membership.spending_within_months':
      '{{months}} ヶ月以内の累計消費額が {{spending}} に達するとアップグレードできます',
    'users.membership.spending_single_purchase':
      '1 度の消費額が {{spending}} に達するとアップグレードできます',
    'users.membership.all.spending_within_months':
      '{{months}} か月以内の累計消費額が {{spending}} に達しました',
    'users.membership.all.spending_single_purchase':
      '1 回の購入金額が {{spending}}に達しました',
    'users.membership.extend_valid_period':
      'メンバーシップ期間{{months}}ヶ月以内の{{ type === "within_interval" ? "累計" : "1回の" }}消費額が {{spending}}に達しました',
    'users.membership.all_tiers': 'すべてのメンバーレベルルールを表示',
    'users.membership.all_tiers.condition': 'メンバーレベルルール',
    'users.membership.all_tiers.description':
      'メンバーの有効期間内に更新条件を達成しなかった場合、自動でダウングレードします。',
    'users.membership.tier.shopping_discount': 'ショッピング {{割引}} 割引',
    'users.membership.tier.upgrade.condition':
      'このレベルのアップグレード条件:',
    'users.membership.tier.upgrade.condition.dollar':
      '現在、 {{ dollar }} 以上の注文はありません。',
    'users.membership.tier.upgrade.condition.continue':
      '引き続きお買い物をお楽しみください！',
    'users.membership.tier.extend': '{{tier}} の更新条件をクリアしていますか?',
    'users.membership.tier.upgrade.to_next_level.single':
      'アップグレード条件を満たしていますか?',
    'users.membership.tier.upgrade.to_next_level.within':
      '{{month}} ヶ月内の累計消費金額',
    'users.membership.tier.upgrade.completed': 'アップグレード対象',
    'users.membership.tier.upgrade.gap_dollar':
      'あと {{ dollar }}でアップグレード',
    'users.membership.tier.expire.date': '有効期間 ：',
    'users.membership.tier.extend.condition': 'メンバーシップ更新条件：',
    'users.membership.tier.extend.single_purchase':
      'メンバーシップ期間{{month}} ヶ月内で {{dollar}} を超える注文はありません',
    'users.membership.tier.extend.single_purchase.can_extend':
      '{{month}} ヶ月以内に {{dollar}} を超える注文がある場合、有効期限になるとメンバーシップが自動で更新されます。',
    'users.membership.tier.extend.top_level.single_purchase':
      'メンバーシップ期間内に {{dollar}} を超える注文はありません。',
    'users.membership.tier.extend.top_level.single_purchase.can_extend':
      'メンバーシップ期間内の注文が {{dollar}} を超えました。有効期限になるとメンバーシップが自動で更新されます',
    'users.membership.tier.extend.within_interval':
      'メンバーシップ有効期間は {{month}} ヶ月間で、現在の累計消費額は {{spending}}です。あと {{dollar}} で更新できます',
    'users.membership.tier.extend.within_interval.can_extend':
      'メンバーシップ有効期限は {{month}} ヶ月で、累計消費額が{{dollar}}に達しました。有効期限が過ぎるとメンバーシップが自動で更新されます。',
    'users.membership.tier.extend.top_level.within_interval':
      'あと {{dollar}}で 更新',
    'users.membership.tier.extend.top_level.within_interval.can_extend':
      'おめでとうございます！有効期限になると自動で更新されます',
    'users.membership.tier.expire.month': '{{month}} ヶ月',
    'users.membership.tier.discount_percentage.caption': '{{ value }}割引',

    'membership.profile.birthday': '生年月日',
    'birthday_picker.year.placeholder': '年',
    'birthday_picker.month.placeholder': '月',
    'birthday_picker.date.placeholder': '日',
    'form.validation.birthday.required': '生年月日は必須です',
    'form.validation.birthday.invalid': '生年月日の日付が無効です',
    'form.validation.birthday.invalid.minimum_age_limit':
      '生年月日が無効です。{{minimumAgeLimit}} 歳以上である必要があります',
    'users.birthday.faq':
      'オンラインストアの登録と購入には指定の年齢に達している必要があります。',
    'membership.edit.send_me_check_mode': '認証コードを送信',
    'membership.edit.select_saved_mobile_number':
      '保存されている電話番号を選択してください',
    'session.mobile_signup.check_mobile.title':
      '携帯電話番号が正しく入力されているか確認してください。以下の携帯電話番号にSMSを送信します。',
    'session.mobile_signup.check_mobile.your_number': 'あなたの携帯電話番号',
    'session.mobile_signup.check_mobile.send_code': '認証コードを送信',
    'session.mobile_signup.check_mobile.go_back.1':
      '携帯電話番号を間違って入力した場合は、戻ってください',
    'session.mobile_signup.check_mobile.go_back.2': 'もどる',
    'session.mobile_signup.check_mobile.go_back.3': '編集',
    'session.mobile_signup.check_mobile.go_back.3.simplified': '編集',
    'session.mobile_signup.input_code.hint':
      'SMSに送信されたSMS認証コードを入力してください',
    'session.mobile_signup.input_code.hint.simplified':
      '受信した認証コードを入力してください',
    'session.mobile_signup.input_code.placeholder': '認証コード',
    'session.mobile_signup.input_code.submit': '送信済み',
    'session.mobile_signup.input_code.resend.countdown':
      '認証コードを再送 ({{resendCountdown}} 秒)',
    'session.mobile_signup.input_code.resend.countdown.simplified':
      '再送 ({{resendCountdown}} 秒)',
    'session.mobile_signup.input_code.resend': '認証コードを再送',
    'session.mobile_signup.input_code.resend.simplified': '再送',
    'session.forget_passowrd.check_phone.error':
      '携帯電話番号が無効です、再度確認してください',
    'session.mobile_center.check_phone.error':
      'この携帯番号はすでに登録されています',
    'user.sign_up.check_phone.error':
      'これは既存の携帯電話番号です。変更が必要な番号を再度入力してください。',
    'membership.profile.mobile.number.verified':
      'メンバーの携帯電話認証が完了すると、識別のため保存済みの電話番号が上書きされます。',
    'membership.profile.delivery_addresses': '保存済みの住所',
    'users.add.delivery_address.maximum':
      '配送先住所は最大 5 つまで指定できます',
    'users.add.delivery_address': '配送先住所を追加',
    'checkout.address.recipient': '配送先',
    'checkout.address.recipient_phone': '配送先電話番号',
    'member_profile.line.subscribe.error.already_in_used':
      'このLINEアカウントはすでにメンバー登録されています。ストアまでご連絡ください。',
    'member_profile.subscribe': 'サブスクリプション',
    'member_profile.subscribed': '登録済み',
    'member_profile.notification.promotion': '割引プロモーション',
    'member_profile.notification.order': '注文通知',
    'member_profile.subscribe.successfully': 'サブスクリプションに登録しました',
    'member_profile.subscribe.error':
      '登録に失敗しました。ストアまでお問い合わせください',
    'member_profile.line.subscribe.error.already_for_registration':
      '登録に失敗しました。このLINEアカウントは他のメンバーによってすでに登録されています。 LINEでログインの上、再度登録してください。',
    'member_profile.line.subscribe.error.different_id':
      '登録に失敗しました。メンバー登録した LINE アカウントから登録してください。',
    'member_profile.line.subscribe.error':
      '登録に失敗しました。再度LINEにログインしてください',
    'member_profile.facebook.subscribe.error':
      '登録に失敗しました。Facebookに再度ログインしてください',
    'member_profile.social.subscribe.error.already_bound_to':
      '登録に失敗しました。このソーシャルアカウントは別の顧客と連携されています。連携の解除についてはストアまでご連絡ください。',
    'member_profile.email.subscribe.error':
      '購読に失敗しました。まずメールアドレスを入力してから登録してください',
    'member_profile.sms.subscribe.error':
      '登録に失敗しました。まず携帯電話番号を入力してから登録してください',
    'member_profile.unsubscribe.successfully': '登録解除が完了しました',
    'member_profile.unsubscribe.error':
      '登録解除に失敗しました。もう一度お試しください',
    'member_profile.error.unknown': '不明のエラーです',
    'member_profile.error.refresh':
      'ページを更新後、しばらくしてからもう一度お試しください',
    'member_profile.retry': '更新する',
    'member_profile.profile': 'メンバープロフィール',
    'member_profile.subscription': 'サブスクリプション',
    'member_profile.delivery_payment': '配送と支払い情報',
    'member_profile.phone': '連絡先電話',

    'user.credit_card.title': 'クレジットカード',
    'user.credit_card.information':
      'クレジットカード情報（最大{{ max }}枚まで連携可能）',
    'user.add_credit_card': '新しいクレジットカードを追加',
    'user.add_credit_card.credit_card_limit': '最大 {{ max }} 枚のカードが連携',
    'user.add_credit_card.success': 'カードが追加されました',
    'user.add_credit_card.fail':
      'カードを追加できませんでした。もう一度お試しください。',
    'user.add_credit_card.cancel': 'キャンセル',
    'user.add_credit_card.remind':
      'ご注意: クレジットカードを追加すると、SHOPLINE Payments が {{ label }} 円の認証履歴を取得します。この認証履歴に料金は発生しません。',
    'user.add_credit_card.submit': '確定',
    'user.delete_credit_card': 'このカードを削除しますか?',
    'user.delete_credit_card.description':
      'このクレジットカードを削除すると、このカードでのお支払いができなくなります',
    'user.delete_credit_card.description.with_subscription_product':
      'このクレジットカードを削除すると、このカードをクイックペイで使用できなくなります。定期購入商品にこのカードを使用している場合、次回注文時に決済ができない場合があります。決済に失敗した場合は、メンバーセンター > 注文ページ　から再度お支払いください。',
    'user.delete_credit_card.success': 'カードが削除されました',
    'user.delete_credit_card.fail':
      '削除に失敗しました。もう一度お試しください',
    'user.delete_credit_card.cancel': 'キャンセル',
    'user.delete_credit_card.delete': '削除する',
    'user.credit_card.expired': 'カードの有効期限が切れています',
    'user.credit_card_list.delete': '削除',
    'user.credit_card_list.processing': '追加',
    'users.invoice_carrier': 'クラウド型電子請求書管理ツール',
    'users.electronic_invoice_carrier': '電子請求書連携',
    'member_profile.confirm': '変更内容を保存',
    'member_profile.cancel': 'キャンセル',
    'users.save.success': '変更が保存されました',
    'users.error.not_save_mobile_phone':
      'この携帯電話番号は認証されていないため、変更を保存できません',
    'verification.email.trial_merchant.reach_limit.failure':
      'ストアはトライアル中のため、確認メールを送信できません。必要な場合はストアまでご連絡ください。',
  },
};
